module.exports = __webpack_public_path__ + "media/images/pages/commercial/pocstock-explore-5-fd7752658bef2880f22328952b5ca446.png";